export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12.0002 3.7876 8 5.4819-.0045 10.7303h-6.9955V15.07h-2v4.9298H4V9.2693l8.0002-5.4817zM6 10.3234v7.6764h3.0002V13.07h6v4.9298h2.9963l.0033-7.6766-5.9996-4.1111L6 10.3234z" } }];
export const iconName = 'home';
export const home = { iconName, paths };
export default paths;
